import moment from "moment";
import { fetchQuery } from "../../utils/commonComponent/fetched";
import { DisciplineOptions } from "../disciplineMaster/disiplineConst";
import { generateNumber } from "../../utils/utils";

export const fetchInwardDetails = async (params, setInputStates) => {
  try {
    const [inward] = await fetchQuery(`select * from inward where status = 1 and id = ${params.id}`);
    setInputStates(inward);
  } catch (error) {
    console.error("Error fetching inward:", error);
  }
};

export const fetchSettings = async (setSettingList) => {
  try {
    const settings = await fetchQuery(`select * from settings where status = 1`);
    setSettingList(settings);
  } catch (err) {
    console.log("Setting:", err);
  }
}

export const fetchDisciplineDetails = async (inputStates, setDisGroupList) => {
  try {
    const gropuList = await fetchQuery(`select * from discipline where status = 1 and name = ${inputStates.disciplineId}`);
    setDisGroupList(gropuList);
  } catch (error) {
    console.error("Error fetching Discipline data:", error);
  }
};

export const fetchJobDetails = async (jobID, updateInputObject, params) => {
  try {
    const [jobDetailsById] = await fetchQuery(`select * from jobRegister where status = 1 and id = ${jobID}`);
    updateInputObject("jobDate", jobDetailsById?.jobDate);
    if (params.id == 0) {
    updateInputObject("customerName", jobDetailsById?.clientName);
    updateInputObject("contactPerson", jobDetailsById?.contactPerson);
    updateInputObject("address", jobDetailsById?.address);
    updateInputObject("principleClient", jobDetailsById?.principleClient);
    }
  } catch (error) {
    console.error("Error fetching inward:", error);
  }
};

export const fetchDisciplineGroupDetails = async (inputStates, setmaterialList) => {
  try {
    const { disciplineId, groupId } = inputStates;
    const materialList = await fetchQuery(`select * from materialScope where status = 1 and discplineId = ${disciplineId} and groupId = ${groupId}`);
    setmaterialList(materialList);
  } catch (error) {
    console.error("Error fetching Discipline data:", error);
  }
};

export const fetchInwardTestRows = async (params, setTestRows) => {
  try {
    const inwardTestRows = await fetchQuery(`select * from inwardTests where status = 1 and inwardId = ${params.id}`);
    let upodatedRows = inwardTestRows?.map(row => ({
      ...row,
      testId: row.testId && typeof row.testId === "string"
        ? row.testId.split(",").map(id => parseInt(id, 10))
        : row.testId
    }))
    setTestRows(upodatedRows);
  } catch (error) {
    console.error("Error fetching unit data:", error);
  }
};

export const fetchUnitListdisGrpWise = async (inputStates, setunitList) => {
  try {
    const { disciplineId, groupId } = inputStates;
    // const unitList = await fetchQuery(`select * from unit where disciplineId = ${disciplineId} and groupId = ${groupId}`);
    setunitList([]);
  } catch (error) {
    console.error("Error fetching unit data:", error);
  }
};

export const fetchInwardOfficeDetails = async (params, setOfficeFormData) => {
  try {
    const [inward] = await fetchQuery(`select * from inward_officeReview where status = 1 and inwardId = ${params.id}`);
    setOfficeFormData(inward);
  } catch (error) {
    console.error("Error fetching inward:", error);
  }
};

export const fetchInwardCSRFDetails = async (params, setCSRFFormData) => {
  try {
    const [csrf] = await fetchQuery(`select * from csrfForm where inwardId = ${params.id}`);  
    setCSRFFormData(csrf || {});
  } catch (error) {
    console.error("Error fetching CSRF data:", error);
  }
};

export const fetchTestMethodByMaterialId = async (materialId) => {
  try {
    const testList = await fetchQuery(`select * from materialTestings where status = 1 and materialId = ${materialId}`);
    return testList.map(item => ({
      id: item.id,
      testName: item.testName,
      testMethod: item.testMethod,
      materialId: item.materialId,
      observationType: item.observationType,
      status: item.status
    }));
  } catch (error) {
    console.error("Error fetching test methods:", error);
    return [];
  }
};

export const fetchTestMethodAll = async () => {
  try {
    const testList = await fetchQuery(`select * from materialTestings where status = 1 and location = 2`);
    return testList.map(item => ({
      id: item.id,
      testName: item.testName,
      testMethod: item.testMethod,
      materialId: item.materialId,
      observationType: item.observationType,
      status: item.status
    }));
  } catch (error) {
    console.error("Error fetching test methods:", error);
    return [];
  }
};

export const lastInwardRefNo = async (updateInputObject, inputStates, settingList) => {
  try {
    const locationId = String(inputStates?.location);
    const isSite = locationId == 2;
    const datePrefix = moment().format("YYYY/MM");
    const prefixMap = { 
      "1": "L",
      "2": "S",
      "3": "M",
    };
    const prefix = prefixMap[locationId] || "L";

    if (isSite) {
      const result = await fetchQuery(
        `SELECT labReferenceNo FROM inward WHERE location = '2' AND status = 1 ORDER BY id DESC LIMIT 1`
      );
      const lastNo = parseInt(result[0]?.labReferenceNo?.split("-").pop()) || 0;

      const labRefNoSetting = settingList?.find(s => s.keyName === "labRefNo");
      const template = labRefNoSetting?.value || `${datePrefix}/S-{no}`;
      const props = { entryDate: inputStates?.entryDate || new Date(), facility: "Site", prefix };
      updateInputObject("labReferenceNo", generateNumber(template, lastNo + 1, props));

    } else {
      const selectedDiscipline = DisciplineOptions.find((d) => d.id == inputStates?.disciplineId)?.label;

      if (!selectedDiscipline) {
        updateInputObject("labReferenceNo", "");
        return;
      }

      const result = await fetchQuery(
        `SELECT labReferenceNo FROM inward WHERE location = '${locationId}' AND disciplineId = '${inputStates?.disciplineId}' AND status = 1 ORDER BY id DESC LIMIT 1`
      );
      const lastNo = parseInt(result[0]?.labReferenceNo?.split("-").pop()) || 0;

      const labRefNoSetting = settingList?.find(s => s.keyName === "labRefNo");
      const template = labRefNoSetting?.value || `${datePrefix}/{discipline}/{prefix}-{no}`;
      const facilityMap = { "1": "Lab", "2": "Site", "3": "Mobile" };
      const props = { entryDate: inputStates?.entryDate || new Date(), discipline: selectedDiscipline, facility: facilityMap[locationId] || "Lab", prefix };
      updateInputObject("labReferenceNo", generateNumber(template, lastNo + 1, props));
    }
  } catch (error) {
    console.error("Error fetching last labReferenceNo:", error);
  }
};

export const fetchJobRegisterDetails = async (setJobList) => {
  try {
    const jobRegister = await fetchQuery(`select * from jobRegister where status = 1`);
    const inward = await fetchQuery(`select * from inward where status = 1`);
    const inwardJobIds = inward.map(item => item.jobId);
    // Filter jobRegister by excluding jobIds found in inward
    const filteredJobRegister = jobRegister.filter(job => !inwardJobIds.includes(job.id));
    setJobList(filteredJobRegister);
  } catch (error) {
    console.error("Error fetching jobregister:", error);
  }
};

export const fetchEmployeeTechnicalManager = async (setemployeeList) => {
  try { 
    const employeeList = await fetchQuery(`SELECT u.id, u.userName, e.name AS employeeName, ed.hrDesignation FROM userMaster u JOIN employeeOtherData ed ON ed.employeeId = u.employeeId AND ed.hrDesignation = 'Technical Manager' JOIN employees e ON e.id = u.employeeId WHERE u.status != -1 ORDER BY u.id DESC`);
    setemployeeList(employeeList);
  } catch (err) {
    console.error("Error fetching employee:", err);
  }
}
// export const fetchClients = async (updateInputObject, inputStates) => {
//   console.log(inputStates?.customerName)
//   try {
//     const clientList = await fetchQuery("tables/clientMaster", `&where=(id,eq,${inputStates?.customerName})`);
//     let firstClientRaw = clientList?.[0]?.contact;
//     let contacts = [];
//     // Parse the contact field if it's a stringified JSON array
//     try {
//       contacts = JSON.parse(firstClientRaw);
//     } catch (parseError) {
//       console.warn("Failed to parse contact JSON:", parseError);
//     }
//     const contactPersonName = contacts?.[0]?.contactPersonName?.trim() || "";
//     updateInputObject("contactPerson", contactPersonName);
//   } catch (err) {
//     console.error("Error fetching cleints:", err);
//   }
// };

export const fetchObservationTypeByTestIds = async (testIds) => {
  try {
    const ids = testIds.join(",");
    const result = await fetchQuery(
      `select id, observationType from materialTestings where status = 1 and id in (${ids})`
    );
    // Return a map { testId: observationType }
    const map = {};
    result.forEach(item => { map[item.id] = item.observationType; });
    return map;
  } catch (error) {
    console.error("Error fetching observationType by testIds:", error);
    return {};
  }
};